const endpoint = "https://ro2b.cuba-lv.com"

const cpoint = "https://central-backend.cuba-lv.com"
const startpoint = `${cpoint}/`

const mediapoint = "https://s3-media.cuba-lv.com"

const gamePlace = { studio: "tbilisi", room: "ro2-room" }
const name = "Azia Roulette"
const type = "azia-roulette"
const logo = "azialogo"

export { endpoint, mediapoint, startpoint, gamePlace, name, type, logo }
